/**
 * Stato di una mail della coda in uscita della Smart Inbox.
 * Mappa 1:1 l'enum backend OutgoingMessageStatus (it.dvel.crm.util.constants.OutgoingMessageStatus):
 *   0 = PENDING, 1 = SENT, 2 = CANCELLED, 3 = FAILED.
 * Conversione int <-> union string in outgoingMessageMappers.
 */
export type OutgoingMessageStatus = 'pending' | 'sent' | 'cancelled' | 'failed';

/** Descrittore UI di ciascuno stato: chiave i18n e color token MUI per il Chip. */
export const OUTGOING_MESSAGE_STATUSES: {
  value: OutgoingMessageStatus;
  label: string;
  color: 'default' | 'warning' | 'info' | 'success' | 'error';
}[] = [
  { value: 'pending', label: 'outgoingMessage.statuses.pending', color: 'warning' },
  { value: 'sent', label: 'outgoingMessage.statuses.sent', color: 'success' },
  { value: 'cancelled', label: 'outgoingMessage.statuses.cancelled', color: 'default' },
  { value: 'failed', label: 'outgoingMessage.statuses.failed', color: 'error' },
];

/** Invio, modifica e annullamento valgono solo per una mail non partita né annullata. */
export function isActionable(status: OutgoingMessageStatus): boolean {
  return status === 'pending' || status === 'failed';
}

export interface OutgoingMessage {
  outgoingMessageId: number;
  groupId: number;
  /** `0` = servizio di posta del portale, senza casella. */
  mailboxId: number;
  mailboxEmailAddress: string | null;
  senderName: string | null;
  subject: string;
  body: string;
  htmlFormat: boolean;
  status: OutgoingMessageStatus;
  statusDate: string | null;
  errorMessage: string | null;
  createDate: string;
  to: string[];
  cc: string[];
  bcc: string[];
  /** Il `Message` OUT della stessa mail, se partita, reimportata e visibile; altrimenti `null`. */
  messageId: number | null;
  /** Il `Message` ricevuto a cui la mail risponde, se nel CRM e visibile; altrimenti `null` (POLL-6). */
  replyToMessageId: number | null;
}

/** Modifica: sostituisce oggetto, corpo e destinatari. */
export interface OutgoingMessageUpdatePayload {
  subject: string;
  body: string;
  to: string[];
  cc: string[];
  bcc: string[];
}
